module.exports = require("npm:swagger-parser@4.0.0-beta.2/lib/index.js");